import { Component, OnInit, OnDestroy, HostListener, AfterViewInit, ElementRef, Renderer2 } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { StorageService } from '../../../app/shared/_services/storage.service';
import { HeaderService } from '../../../app/shared/_services/header.service';
import { MenuService } from '../../../app/shared/_services/menu.service';
import { environment } from '../../../environments/environment';
import { Observable, fromEvent, Subscription } from 'rxjs';
import { MetaService } from '@ngx-meta/core';
import { IImage } from 'ng-simple-slideshow/public_api';
import { LocalizeRouterService } from 'localize-router';
import { ApiService } from '../../../app/shared/_services/api.service';

@Component({
  selector: 'app-main-home',
  templateUrl: './home.component.html',
})
export class MainHomeComponent implements OnInit, AfterViewInit, OnDestroy {

  constructor(
    private api: ApiService,
    private route: ActivatedRoute,
    private header: HeaderService,
    private menu: MenuService,
    private storage: StorageService,
    private router: Router,
    private meta: MetaService,
    private localize: LocalizeRouterService) {
    this.isMobile = window.innerWidth < environment.mobileBreakpoint;
  }

  slideshow;
  blocchi;

  isMobile;
  strutturaGradinatore;
  queryParamsGradinatore;

  subs: Subscription[] = [];

  menuOpen;

  images: IImage[] = [];

  ngOnInit() {
    this.slideshow = this.route.snapshot.data.HomepageResolver.slideshow;
    this.blocchi = this.route.snapshot.data.HomepageResolver.blocchi;
    if (this.storage.isBrowser) {
      this.subs.push(fromEvent(window, 'scroll').subscribe(() => this.onScroll()));
    }

    if (this.isMobile) {
      this.api.strutturaConfiguratore().subscribe(res => {
        this.strutturaGradinatore = res;
      });
    }

    this.meta.setTitle(`HOMEPAGE_TITLE`);
    this.meta.setTag('description', 'HOMEPAGE_DESCRIPTION');
    this.meta.setTag('keywords', 'HOMEPAGE_KEYWORDS');

    this.header.setHomepage.next(true);
    this.menu.setIndex.next(1);

    if (this.slideshow) {
      this.images = this.slideshow.filter(slide => slide.foto).map(slide => {

        
        const formato = window.innerWidth > 768 ? '_landscape_16_9_desktop' : '_landscape_4_3_mobile';
        const nomeFile = slide.foto.path.split('.').shift();
        const estensione = slide.foto.path.split('.').pop();
        const url = `${environment.allegati.filePath}${nomeFile}${formato}.${estensione}`;

        const caption = slide.titolo;
        const title = slide.titolo;
        const clickAction = () => {
          if (slide.esterno) {
            window.open(slide.link, '_blank');
          } else {
            window.location.href = this.appHref(slide.link);
          }
        };
        return { url, caption, title, clickAction };
      });
    }
  }

  ngOnDestroy() {
    this.header.setHomepage.next(false);
    this.subs.forEach(s => s.unsubscribe());
  }

  ngAfterViewInit() {
  }

  onScroll() {
    const y = window.scrollY;
    if (y > 300) {
      this.header.setTrasparente.next(false);
    } else {
      this.header.setTrasparente.next(true);
    }
  }

  stopVideo() {
    const videos = document.querySelectorAll('iframe, video');
    Array.prototype.forEach.call(videos, (video) => {
      if (video.tagName.toLowerCase() === 'video') {
        video.pause();
      } else {
        const src = video.src;
        video.src = src;
      }
    });
  }

  appHref(appHref): string {
    let href = appHref;
    const qParams = appHref.split('?')[1];

    href = qParams ?
      this.localize.translateRoute(appHref.split('?')[0]).toString() + '?' + qParams :
      this.localize.translateRoute(appHref).toString();

    const baseHref = environment.baseHref;
    if (baseHref) { href = baseHref + href; }
    return href;
  }

  queryParamsChange(event) {
    this.queryParamsGradinatore = event;
  }

  risultatiStaffeChange() {
    this.router.navigate([this.localize.translateRoute('/configuratore')], {queryParams: this.queryParamsGradinatore});
  }
}
